import { GridViewSharp, FormatListBulleted } from '@mui/icons-material';
import React from 'react';

import {
  ViewToggleContainer,
  ViewLabel,
  ToggleButtonGroup,
  ToggleButton,
} from './components';

export type ViewType = 'grid' | 'list';

export interface ViewToggleProps {
  currentView: ViewType;
  onViewChange: (view: ViewType) => void;
}

export const ViewToggle: React.FC<ViewToggleProps> = ({
  currentView,
  onViewChange,
}) => {
  return (
    <ViewToggleContainer>
      <ViewLabel>View:</ViewLabel>
      <ToggleButtonGroup>
        <ToggleButton
          isActive={currentView === 'grid'}
          buttonPosition="left"
          onClick={() => onViewChange('grid')}
          role="button"
          aria-label="Grid view"
          aria-pressed={currentView === 'grid'}
        >
          <GridViewSharp />
        </ToggleButton>
        <ToggleButton
          isActive={currentView === 'list'}
          buttonPosition="right"
          onClick={() => onViewChange('list')}
          role="button"
          aria-label="List view"
          aria-pressed={currentView === 'list'}
        >
          <FormatListBulleted />
        </ToggleButton>
      </ToggleButtonGroup>
    </ViewToggleContainer>
  );
};
